import React from 'react';
import { motion } from 'framer-motion';

const CampfireView = ({ poem, onBack }) => {
  return (
    <div style={{ minHeight: '100vh', background: '#1F2937', color: '#FFA500', padding: '40px', textAlign: 'center' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
        <h2>{poem?.title || 'Untitled'}</h2>
        <p style={{ marginTop: '40px', fontSize: '18px', lineHeight: '1.8' }}>{poem?.content}</p>
        <p style={{ marginTop: '30px', fontStyle: 'italic' }}>— {poem?.author}</p>
        <button onClick={onBack} style={{ marginTop: '40px', padding: '12px 24px', cursor: 'pointer' }}>
          ← Back
        </button>
        <p style={{ marginTop: '40px', opacity: 0.5, fontSize: '14px' }}>Campfire view - Coming soon</p>
      </motion.div>
    </div>
  );
};

export default CampfireView;
